var hd = document.getElementsByTagName('head')[0];
var jq = document.createElement('script');
jq.setAttribute('type', 'text/javascript');
jq.setAttribute('src', 'https://code.jquery.com/jquery-3.6.3.min.js');
hd.appendChild(jq);

jq.onload = function() {
  jQuery(document).ready(function(){
    jQuery(document).on('click', '#SizeBuddyButton', function () {
      if(jQuery(".quick-buy-modal__content").length) {
        var pid = jQuery(".quick-buy-modal__content").attr("pid");
        var SizeBuddyProductData = SizeBuddyData[pid];
        openSizeBuddy(
          SizeBuddyProductData["category"], // Fixed to shoes
          SizeBuddyProductData["brand"], // Fixed to Mason Garments
          SizeBuddyProductData["fit"], // Product specific
          SizeBuddyProductData["gender"], // Fixed to U(nisex)
          "e58aa0d5-1365-41c7-b488-7dca5c589420", // Fixed
          SizeBuddyProductData["size_type"], // Fixed to eu
          SizeBuddyProductData["possible_sizes"], // Product specific
          pid,
          SizeBuddyProductData["title"] // Product specific
        );
      }
    });
    
    function checkQuickBuy() {
      var is_qb_load = setInterval(function() {
        if(jQuery('button[load_status="end"]').length) {
          var pfid = jQuery(".quick-buy-modal__content").attr("pfid");
          var sbt = jQuery(".quick-buy-modal__content").attr("sbt");
          jQuery("#" + pfid).find('button[type="submit"]').html(sbt).prop('disabled', true);
          jQuery('button[class="select"] > span').html(sbt);
          
          clearInterval(is_qb_load);
          jQuery('button[load_status="end"]').attr("load_status", "done");
        }
      }, 1000);
    }
    
    jQuery(document).on('click', 'button[class="product-card__quick-add-button"]', function () {
      jQuery(this).attr("load_status", "start");
      checkQuickBuy();
    });
    
    jQuery(document).on('click', '.quick-buy-modal__content > button[type="button"][role="option"]', function () {
      var pfid = jQuery(".quick-buy-modal__content").attr("pfid");
      var adct = jQuery(".quick-buy-modal__content").attr("adct");
      jQuery("#" + pfid).find('button[type="submit"]').html(adct).prop('disabled', false);
    });
    
    var glide_slider = [];
    if(jQuery(".glide").length && jQuery(".collection").length && jQuery(".collection__main").length) {
      jQuery(".glide").each(function(){
        var prd_handle = jQuery(this).attr("id");
        var glide = new Glide('.' + prd_handle, {
          type: 'carousel',
          perView: 1,
          perTouch: 1,
          focusAt: 'center'
        }).mount();
        glide.on(['swipe.end', 'run.after'], function() {
          var curr_img = jQuery('#' + prd_handle).find('img[img_pos="'+glide.index+'"]');
          curr_img.attr("src", curr_img.attr("data-src"));
        });
        glide_slider.push(glide);
      });
    }

    jQuery(document).on('click', '.collection-toolbar__button', function () {
      for(i=0; i<glide_slider.length; i++) {
        glide_slider[i].update();
      }
      jQuery('.glide__track').attr("layout", jQuery(this).attr("value"));
      jQuery('.product-card__figure').attr("layout", jQuery(this).attr("value"));
      jQuery('.area_glide__bullet').attr("layout", jQuery(this).attr("value"));
      jQuery('.glide__slides').attr("layout", jQuery(this).attr("value"));
    });

    function checkAlmostSoldOut(curr_sl_size) {
      var size_inv = jQuery("#size_qty_data").html().split("|");
      var size_Arr = [];
      for(i=0; i<size_inv.length; i++) {
        var temp_size = size_inv[i].split("#");
        size_Arr[temp_size[0]] = temp_size[1];
      }
      if(size_Arr[curr_sl_size] > 0 && size_Arr[curr_sl_size] <= 3) {
        if(!jQuery(".almost_sold_out").length) {
          jQuery(".buy-buttons").parent("div").prepend('<div class="almost_sold_out">'+window.translations.almostSoldout+'</div>');
        }
      } else {
        jQuery(".almost_sold_out").remove();
      }
    }
    
    jQuery(document).on('click', 'input[name="option1"]', function () {
      checkAlmostSoldOut(jQuery(this).val());
    });
    
    jQuery(document).on('click', 'button[role="option"]', function () {
      checkAlmostSoldOut(jQuery(this).attr("title"));
    });
  });  
}
